module.exports = __webpack_public_path__ + "img/right-arrow.5f9d9bbd.svg";